module.exports = [{"name":"United States","code":"US","currency":"USD","price":7.99},{"name":"Canada","code":"CA","currency":"CAD","price":8.49},{"name":"Australia","code":"AU","currency":"AUD","price":7.99},{"name":"United Kingdom","code":"GB","currency":"GBP","price":6.99}]


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/json/countries.json
// module id = OJXj
// module chunks = 1